import React from 'react';
import schoolImage from '../asets/school-image.jpg'; // Adjust the path based on your project structure
import locationImage from '../asets/Location.jpg'; // Path for the location image

const Location = () => {
  return (
    <div className="location" style={{ display: 'flex', alignItems: 'center', backgroundColor: '#e0f7fa', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)' }}>
      <img src={locationImage} alt="School" style={{ width: '30%', borderRadius: '8px', marginRight: '20px' }} /> {/* Reduced size */}
      <div style={{ flex: 1 }}>
        <h2 style={{ color: '#00796b' }}>Our Location</h2>
        <p>
          Sahaj Public School | Best CBSE School<br />
          Dupada Road, Shajapur Madhya Pradesh 465001
        </p>
        <p>Contact Details:</p>
        <p>Mobile No.: 7000434300 </p>
        <p>Phone No. : 07364-299088
</p>
        <a href="https://www.google.com/maps/place/Sahaj+Public+School/@23.4202938,76.2617673,15z/data=!4m6!3m5!1s0x39635a103df43c19:0x7760fa16aa5371c8!8m2!3d23.4227202!4d76.2583375!16s%2Fg%2F1tj5657z?entry=ttu&g_ep=EgoyMDI1MDEyOS4xIKXMDSoJLDEwMjExMjM0SAFQAw%3D%3D" target="_blank" rel="noopener noreferrer" style={{ color: '#00796b', textDecoration: 'underline' }}>
          View on Google Maps
        </a>
      </div>
      <img src={schoolImage} alt="Location" style={{ width: '30%', borderRadius: '8px', marginLeft: '20px' }} />
    </div>
  );
};

export default Location;
